import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useController } from '@rest-hooks/react';

import OrganizationResource from 'resources/organization/OrganizationResource';

import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';

import CountrySelector from 'components/AddressForm/CountrySelector';
import CurrencyField from 'components/CurrencyField';

import { useError } from '../utils/useErrorController';

import Button from 'ui/Button';
import FormSection from 'ui/FormSection';

const LocationCheckModal = ({ organization }) => {

  if (!organization) {
    return null;
  }

  const [isModalOpen, setIsModalOpen] = useState(!organization?.country);
  const [formData, setFormData] = useState({
    country: organization?.country,
    currency: organization?.currency
  });

  const {fetch} = useController();
  const {loading, setLoading, handleError} = useError();

  const handleCountryChange = (newData) => {
    setFormData(prevData => ({
      ...prevData,
      country: newData.country
    }));
  };

  const handleCurrencyChange = (event) => {
    setFormData(prevData => ({
      ...prevData,
      currency: event.target.value
    }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      await fetch(OrganizationResource.update(), {id: organization.id}, formData);
      await OrganizationResource.detail(), {id: organization.id};
      setIsModalOpen(false);

      setLoading(false);
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <Dialog 
      open={isModalOpen} 
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { padding: 2 }
      }}
    >
      <DialogTitle>
        <Typography variant="h5" component="div">
          Confirm Organization Details
        </Typography>
      </DialogTitle>
      <DialogContent>
        <FormSection slim>

          <Typography variant="body1" sx={{ mb: 3 }}>
            Before proceeding, please confirm your Club&apos;s country and preferred currency.
          </Typography>

          <CountrySelector 
            data={{ country: formData.country }}
            onDataChange={handleCountryChange}
            disabled={loading}
          />

          <CurrencyField
            currency={formData.currency}
            onCurrencyChange={handleCurrencyChange}
            isDisabled={loading}
          />

        </FormSection>
      </DialogContent>
      <DialogActions>
        <Button 
          highlighted
          fullwidth
          onClick={handleSubmit}
          disabled={!formData.country || !formData.currency || loading}
          loading={loading}
        >
          Confirm and Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

LocationCheckModal.propTypes = {
  organization: PropTypes.object
};

export default LocationCheckModal;